import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
  nanoid,
} from '@reduxjs/toolkit'
import { ToasterMessage } from 'shared/models/Toaster'

export const toasterMessages = createEntityAdapter<ToasterMessage, string>({
  selectId: (message) => message.id ?? '',
})

const toasterSlice = createSlice({
  name: 'toaster',
  initialState: toasterMessages.getInitialState(),
  reducers: {
    removeToasterMessage: toasterMessages.removeOne,
  },
  extraReducers: (builder) => {
    builder.addCase(addToasterMessage.fulfilled, (state, action) => {
      toasterMessages.addOne(state, action.payload)
    })
  },
})

const addToasterMessage = createAsyncThunk<ToasterMessage, ToasterMessage>(
  'toaster/addToasterMessage',
  async (arg, api) => {
    const id = nanoid()

    setTimeout(() => {
      api.dispatch(toasterSlice.actions.removeToasterMessage(id))
    }, arg.duration || 5000)

    return { ...arg, id: arg.id || id }
  }
)

export const { reducer, actions } = toasterSlice
export { addToasterMessage }
